import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import baremcLogo from "../assets/baremc-logo.png";
import { usePageContent, PageEditor } from "../components/shared/PageEditor";

const DEFAULTS = {
  hero_title: "ANDRE KLUBBER",
  hero_subtitle: "Udforsk det danske MC-miljø",
  logo_url: "",
  description: "Her kan du finde information om andre motorcykelklubber i Danmark. BareMC er en samlet oversigt over klubber, arrangementer og fællesskabet i det danske MC-miljø.",
  button_text: "Besøg BareMC",
  button_link: "https://www.baremc.dk",
  footer_note: "Linket åbner i en ny fane",
};

const SCHEMA = [
  { name: "hero_title", label: "Hovedtitel", type: "text" },
  { name: "hero_subtitle", label: "Undertekst", type: "text" },
  { name: "logo_url", label: "Logo (upload eller URL)", type: "image" },
  { name: "description", label: "Beskrivelse", type: "textarea" },
  { name: "button_text", label: "Knaptekst", type: "text" },
  { name: "button_link", label: "Knap-link (URL)", type: "link", placeholder: "https://..." },
  { name: "footer_note", label: "Note nederst", type: "text" },
];

const AndreKlubberPage = () => {
  const navigate = useNavigate();
  const { content } = usePageContent("andre-klubber", DEFAULTS);
  const c = { ...DEFAULTS, ...content };

  return (
    <div className="min-h-screen bg-black pt-20 pb-16 px-4" data-testid="andre-klubber-page">
      <PageEditor pageKey="andre-klubber" schema={SCHEMA} defaults={DEFAULTS} />

      <div className="max-w-4xl mx-auto">
        <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-white transition-all mb-4" data-testid="back-btn">
          <ArrowLeft className="w-4 h-4" /> Tilbage
        </button>

        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-6xl font-['Oswald'] font-bold text-white mb-4" style={{ textShadow: "2px 2px 4px rgba(0,0,0,0.5)" }}>
            {c.hero_title}
          </h1>
          <p className="text-gray-400 text-lg">{c.hero_subtitle}</p>
        </div>

        <div className="bg-gradient-to-br from-neutral-900 to-neutral-800 rounded-2xl p-8 sm:p-12 border border-white/10">
          <div className="flex justify-center mb-8">
            <img src={c.logo_url || baremcLogo} alt="" className="w-48 sm:w-64 h-auto" />
          </div>

          <div className="text-center mb-10">
            <p className="text-gray-200 text-lg leading-relaxed max-w-2xl mx-auto whitespace-pre-wrap">{c.description}</p>
          </div>

          {c.button_link && (
            <div className="text-center">
              <a
                href={c.button_link}
                target="_blank"
                rel="noopener noreferrer"
                className="radial-btn px-10 py-4 rounded-xl text-lg inline-flex items-center gap-3 hover:scale-105 transition-transform"
                data-testid="andre-klubber-link"
              >
                <span className="text-xl">🏍️</span>
                {c.button_text}
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          )}
        </div>

        {c.footer_note && (
          <div className="text-center mt-8">
            <p className="text-gray-500 text-sm">{c.footer_note}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AndreKlubberPage;
